import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { CustomerFacade, LoginFacade, NotificationFacade } from '@ridango/components';
import { BaseComponent } from '@ridango/core';

import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    templateUrl: './customer-forget-landing-page.component.html'
})
export class CustomerForgetLandingPageComponent extends BaseComponent implements OnInit, OnDestroy {
    isDeletionSuccess$: Observable<boolean> = this.customerFacade.isDeletionSuccess$;
    error$: Observable<any> = this.customerFacade.error$;

    constructor(
        private notification: NotificationFacade,
        private translate: TranslateService,
        private router: Router,
        private route: ActivatedRoute,
        private loginFacade: LoginFacade,
        private customerFacade: CustomerFacade
    ) {
        super();
    }

    ngOnInit() {
        this.route.params.pipe(takeUntil(this.componentDestroyed$)).subscribe((params) => {
            if (params && params.token) {
                this.customerFacade.deleteProfile(params.token);
            } else {
                this.router.navigate([this.translate.currentLang, 'login']);
            }
        });

        this.isDeletionSuccess$
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((success) => success && this.handleForget());

        this.error$.pipe(takeUntil(this.componentDestroyed$)).subscribe((error) => error && this.handleError(error));
    }

    handleForget() {
        this.notification.success(this.translate.instant('LOCAL_CUSTOMER_FORGET_SUCCESS'), {
            title: this.translate.instant('LOCAL_CUSTOMER_FORGET_SUCCESS_TITLE'),
            showAfterRouteChange: true
        });

        // TODO: Move to customer epic?
        this.loginFacade.logout();

        this.router.navigate([this.translate.currentLang, 'login']);
    }

    handleError(error) {
        this.notification.error(this.translate.instant(error.error), {
            showAfterRouteChange: true
        });

        this.router.navigate([this.translate.currentLang, 'login']);
    }
}
